import { render, staticRenderFns } from "./list-dapil.vue?vue&type=template&id=feeadba2&"
import script from "./list-dapil.vue?vue&type=script&lang=js&"
export * from "./list-dapil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-dapil.vue"
export default component.exports